import { Box, Button, FormControl, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, useMediaQuery } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../../components/Header';
import { useTheme } from '@emotion/react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { createInstallerPayment, getAllDataElectrician, getAllDataFabricator, getAllDataTechnician, getAllInstallerData, getInstallerPayment, updateInstallerPayment } from '../../../redux/slice/installerpayment.slice';

const AddInstaller = () => {

    const { state } = useLocation();




    const paymentData = state?.v;
    const isMobile = useMediaQuery('(max-width:500px)');
    const UserId = paymentData?.installerName;
    const month = state?.month;
    // const type = state?.type;
    const theme = useTheme();
    const fabricatedata = useSelector(state => state.installerpayment.fabricator);
    const electricianata = useSelector(state => state.installerpayment.electrician);
    const technicianata = useSelector(state => state.installerpayment.technician);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const id = state?.id;
    const assignInstaller = useSelector(state => state.installerpayment.assignInstaller);

    console.log(id);

    const routerLocation = useLocation();
    const { v, billNo, electricians, type } = routerLocation.state || {};

    const [isEditMode, setIsEditMode] = useState(!!electricians);
    const [existingData, setExistingData] = useState(electricians || []);


    const formatDateForInput = (dateStr) => {
        if (!dateStr) return '';
        const [dd, mm, yyyy] = dateStr.split('/');
        return `${yyyy}-${mm}-${dd}`;
    };

    useEffect(() => {
        if (isEditMode && existingData.length) {
            const updated = existingData.map(item => ({
                _id: item._id,
                type: state.type,
                PaymentDate: formatDateForInput(new Date(item.paymentDate)?.toLocaleDateString()) || '',
                PaymentAmount: item.paymentAmount || '',
                PaymentTDS: item.tds || '',
                PaymentTotal: (
                    Number(item.paymentAmount || 0) + Number(item.tds || 0)
                ).toFixed(2),
            }));

            setValues(prev => ({
                ...prev,
                fileDetails: updated,
            }));
        }
    }, [isEditMode, existingData]);




    const validationSchemas =
        Yup.object({});

    const initialValues = {
        userId: UserId,
        type: type,
        monthPeriod: month,
        fileDetails: [{
            fileNo: '',
            consumerName: '',
            systemSize: '',
            commissionPerKW: '',
            totalCommission: '',
            PaymentDate: '',
            PaymentAmount: '',
            PaymentTDS: '',
            PaymentTotal: '',
        }]
    };

    useEffect(() => {
        // dispatch(getInstallerPayment())
        dispatch(getAllInstallerData())
        dispatch(getAllDataFabricator())
        dispatch(getAllDataElectrician())
        dispatch(getAllDataTechnician())
    }, [dispatch])

    const [installerpayment, setInstallerpayment] = React.useState()




    // useEffect(() => {
    //     if (allInstallerpayment) {
    //         setInstallerpayment(allInstallerpayment.find(v => v._id == id && v.monthPeriod == month))
    //     }
    // }, [id, allInstallerpayment])

    useEffect(() => {
        if (id && installerpayment) {
            setValues(installerpayment);
        }
    }, [id, dispatch, installerpayment]);

    const groupDealersByCommissionPeriod = (fabricatedata) => {
        const grouped = {};
        let isFirstEntry = true;

        fabricatedata?.forEach(fab => {
            const date = new Date(fab.PaymentCreatedAt);
            if (isNaN(date)) {
                console.error("Invalid date for entry:", fab);
                return;
            }
            const year = date.getFullYear();
            const month = date.getMonth() - 1;
            const day = date.getDate();

            const installerName = assignInstaller?.find(u => u._id === fab.assignId)?.Fabricator;

            if (fab.submitDate) {
                const periodKey = `${year}-${month + 1}`;
                const submitKey = `${periodKey}-submitted-${new Date(fab.submitDate).toLocaleDateString('en-GB')}-${installerName}`;
                if (!grouped[submitKey]) {
                    const startDate = isFirstEntry ? new Date(year, month, 1) : new Date(year, month, day);
                    const endDate = new Date(year, month + 1, 0);
                    grouped[submitKey] = {
                        startDate,
                        endDate,
                        formattedStartDate: startDate.toLocaleDateString('en-GB'),
                        formattedEndDate: endDate.toLocaleDateString('en-GB'),
                        fabricatedata: [],
                        submitDate: new Date(fab.submitDate).toLocaleDateString('en-GB'),
                    };
                    isFirstEntry = false;
                    grouped[submitKey].fabricatedata.push(fab);
                } else {
                    grouped[submitKey].fabricatedata.push(fab);
                }
            } else {
                const periodKey = `${year}-${month + 1}`;
                if (!grouped[periodKey]) {
                    const startDate = isFirstEntry ? new Date(year, month, 1) : new Date(year, month, day);
                    const endDate = new Date(year, month + 1, 0);
                    grouped[periodKey] = {
                        startDate,
                        endDate,
                        formattedStartDate: startDate.toLocaleDateString('en-GB'),
                        formattedEndDate: endDate.toLocaleDateString('en-GB'),
                        fabricatedata: [],
                    };
                    isFirstEntry = false;
                    grouped[periodKey].fabricatedata.push(fab);
                } else {
                    grouped[periodKey].fabricatedata.push(fab);
                }
            }
        });

        return grouped;
    };


    const groupElectricianByCommissionPeriod = (electricianata) => {

        const grouped = {};
        let isFirstEntry = true;




        electricianata?.forEach(ele => {
            const date = new Date(ele.PaymentCreatedAt);
            if (isNaN(date)) {
                console.error("Invalid date for dealer:", ele);
                return;
            }
            const year = date.getFullYear();
            const month = date.getMonth() - 1;
            const day = date.getDate();

            const installerName = assignInstaller?.find(u => u._id === ele.assignId)?.Electrician;


            if (ele.submitDate) {
                const periodKey = `${year}-${month + 1}`;
                const submitKey = `${periodKey}-submitted-${new Date(ele.submitDate).toLocaleDateString('en-GB')}-${installerName}`;
                if (!grouped[submitKey]) {
                    const startDate = isFirstEntry ? new Date(year, month, 1) : new Date(year, month, day);
                    const endDate = new Date(year, month + 1, 0);
                    grouped[submitKey] = {
                        startDate,
                        endDate,
                        formattedStartDate: startDate.toLocaleDateString('en-GB'),
                        formattedEndDate: endDate.toLocaleDateString('en-GB'),
                        electricianata: [],
                        submitDate: new Date(ele.submitDate).toLocaleDateString('en-GB'),
                    };
                    isFirstEntry = false;
                    grouped[submitKey].electricianata.push(ele);
                } else {
                    grouped[submitKey].electricianata.push(ele);
                }
            } else {
                const periodKey = `${year}-${month + 1}`;
                if (!grouped[periodKey]) {
                    const startDate = isFirstEntry ? new Date(year, month, 1) : new Date(year, month, day);
                    const endDate = new Date(year, month + 1, 0);
                    grouped[periodKey] = {
                        startDate,
                        endDate,
                        formattedStartDate: startDate.toLocaleDateString('en-GB'),
                        formattedEndDate: endDate.toLocaleDateString('en-GB'),
                        electricianata: [],
                    };
                    isFirstEntry = false;
                    grouped[periodKey].electricianata.push(ele);
                } else {
                    grouped[periodKey].electricianata.push(ele);
                }
            }

        });
        return grouped;
    };

    const groupTechnicianByCommissionPeriod = (technicianata) => {

        const grouped = {};
        let isFirstEntry = true;
        technicianata?.forEach(tech => {
            const date = new Date(tech.PaymentCreatedAt);
            if (isNaN(date)) {
                console.error("Invalid date for dealer:", tech);
                return;
            }
            const year = date.getFullYear();
            const month = date.getMonth() - 1;
            const day = date.getDate();

            const installerName = assignInstaller?.find(u => u._id === tech.assignId)?.Technician;


            if (tech.submitDate) {
                const periodKey = `${year}-${month + 1}`;
                const submitKey = `${periodKey}-submitted-${new Date(tech.submitDate).toLocaleDateString('en-GB')}-${installerName}`;
                if (!grouped[submitKey]) {
                    const startDate = isFirstEntry ? new Date(year, month, 1) : new Date(year, month, day);
                    const endDate = new Date(year, month + 1, 0);
                    grouped[submitKey] = {
                        startDate,
                        endDate,
                        formattedStartDate: startDate.toLocaleDateString('en-GB'),
                        formattedEndDate: endDate.toLocaleDateString('en-GB'),
                        technicianata: [],
                        submitDate: new Date(tech.submitDate).toLocaleDateString('en-GB'),
                    };
                    isFirstEntry = false;
                    grouped[submitKey].technicianata.push(tech);
                } else {
                    grouped[submitKey].technicianata.push(tech);
                }
            } else {
                const periodKey = `${year}-${month + 1}`;
                if (!grouped[periodKey]) {
                    const startDate = isFirstEntry ? new Date(year, month, 1) : new Date(year, month, day);
                    const endDate = new Date(year, month + 1, 0);
                    grouped[periodKey] = {
                        startDate,
                        endDate,
                        formattedStartDate: startDate.toLocaleDateString('en-GB'),
                        formattedEndDate: endDate.toLocaleDateString('en-GB'),
                        technicianata: [],
                    };
                    isFirstEntry = false;
                    grouped[periodKey].technicianata.push(tech);
                } else {
                    grouped[periodKey].technicianata.push(tech);
                }
            }

        });
        return grouped;
    };


    const filteredPaymentData = fabricatedata?.filter(v => {
        return v.requestStatus === 'Approved';
    });
    const filteredPaymentElectrician = electricianata?.filter(v => {
        return v.requestStatus === 'Approved';
    });
    const filteredPaymentTechnician = technicianata?.filter(v => {
        return v.requestStatus === 'Approved';
    });
    const groupedDealers = groupDealersByCommissionPeriod(filteredPaymentData);
    const groupedElectrician = groupElectricianByCommissionPeriod(filteredPaymentElectrician);
    const groupedTechnician = groupTechnicianByCommissionPeriod(filteredPaymentTechnician);






    const filteredGroupedDealers = Object.entries(groupedDealers)
        .filter(([kk, vv]) => kk === state.periodKey)
        .sort(([keyA, dataA], [keyB, dataB]) => {
            return new Date(dataA.startDate) - new Date(dataB.startDate);
        });

    const filteredGroupedElectrician = Object.entries(groupedElectrician)
        .filter(([kk, vv]) => kk === state?.paymentData?.billNo)
        .sort(([keyA, dataA], [keyB, dataB]) => {
            return new Date(dataA.startDate) - new Date(dataB.startDate);
        });


    console.log("filteredGroupedElectrician", groupedElectrician, filteredGroupedElectrician);



    const filteredGroupedTechnician = Object.entries(groupedTechnician)
        .filter(([kk, vv]) => kk === state.periodKey)
        .sort(([keyA, dataA], [keyB, dataB]) => {
            return new Date(dataA.startDate) - new Date(dataB.startDate);
        });

    // const handleSubmit = () => {
    //     const getPaymentDetails = () => {
    //         const groupedData = type === 'fabricator'
    //             ? filteredGroupedDealers
    //             : type === 'electrician'
    //                 ? filteredGroupedElectrician
    //                 : filteredGroupedTechnician;

    //         return groupedData.flatMap(([key, { fabricatedata, electricianata, technicianata }]) => {
    //             const dealers = fabricatedata || electricianata || technicianata || [];
    //             return dealers.map((dealer, index) => {
    //                 const foundItem = dealer.marketData[0];
    //                 const payment = values.fileDetails[index] || {};

    //                 return {
    //                     fileNo: foundItem?.fillNo || 'N/A',
    //                     consumerName: foundItem?.ConsumerName || '',
    //                     systemSize: foundItem?.SystemSizeKw || '',
    //                     commissionPerKW: foundItem?.CommissionPerKW || '',
    //                     totalCommission: dealer.TotalAmount || dealer.Amount || '',
    //                     PaymentDate: payment?.PaymentDate || '',
    //                     PaymentAmount: payment?.PaymentAmount || 0,
    //                     PaymentTDS: payment?.PaymentTDS || 0,
    //                     PaymentTotal: Number(payment?.PaymentAmount || 0) + Number(payment?.PaymentTDS || 0),
    //                 };
    //             });
    //         });
    //     };

    //     const fileDetails = getPaymentDetails();
    //     const totalValue = fileDetails.reduce((acc, dealer) => acc + dealer.PaymentTotal, 0);
    //     const TotalPay = paymentData.amount;
    //     const status = totalValue >= TotalPay ? 'Complete' : 'Pending';

    //     const submissionValues = {
    //         ...values,
    //         status,
    //         type,
    //         fileDetails,
    //     };

    //     console.log("submissionValuessubmissionValues", submissionValues)

    //     validationSchemas.validate(submissionValues, { abortEarly: false })
    //         .then(() => {
    //             setFieldValue({
    //                 ...submissionValues,
    //             });
    //             if (id) {
    //                 delete submissionValues.isActive;
    //                 delete submissionValues.createdAt;
    //                 delete submissionValues.updatedAt;
    //                 // dispatch(updateInstallerPayment({ ...submissionValues, id: submissionValues._id, status, fileDetails }));
    //             } else {
    //                 // dispatch(createInstallerPayment({ ...submissionValues, status, fileDetails }));
    //             }
    //             // navigate('/admin/installer-payment');
    //             resetForm();
    //         })
    //         .catch(validationErrors => {

    //             alert("Please fill in all required fields before submitting.");
    //         });
    // };


    // const handleSubmit = () => {
    //     const details = values.fileDetails || [];

    //     // Collect only valid rows
    //     const validEntries = details
    //         .map((entry, index) => {
    //             const hasAllFields = entry?.PaymentDate && entry?.PaymentAmount && entry?.PaymentTDS;

    //             if (!hasAllFields) return null;

    //             const dealer = state?.electricians?.[index];
    //             const foundItem = assignInstaller?.find(item =>
    //                 item?.marketData?.some(md => md.fillNo === dealer?.fillNo)
    //             );

    //             return {
    //                 _id: dealer?._id || 'N/A',
    //                 paymentDate: entry?.PaymentDate,
    //                 paymentAmount: entry?.PaymentAmount,
    //                 tds: entry?.PaymentTDS,
    //                 type: state.type
    //             };
    //         })
    //         .filter(entry => entry !== null); // only keep valid ones

    //     if (validEntries.length === 0) {
    //         alert("Please fill Date, Payment, and TDS in at least one row before submitting.");
    //         return;
    //     }

    //     console.log("idddd", id);

    //     if (id) {
    //         // delete submissionValues.isActive;
    //         // delete submissionValues.createdAt;
    //         // delete submissionValues.updatedAt;
    //         // dispatch(updateInstallerPayment({ ...submissionValues, id: submissionValues._id, status, fileDetails }));
    //     } else {
    //         console.log('Submitting valid rows:', validEntries);
    //         dispatch(createInstallerPayment(validEntries));
    //     }


    //     // Proceed to send `validEntries` to API or further processing
    // };

    const handleSubmit = () => {
        const details = values.fileDetails || [];

        // Collect only valid rows
        const validEntries = details
            .map((entry, index) => {
                const hasAllFields = entry?.PaymentDate && entry?.PaymentAmount && entry?.PaymentTDS;

                if (!hasAllFields) return null;

                const dealer = state?.electricians?.[index];
                const foundItem = assignInstaller?.find(item =>
                    item?.marketData?.some(md => md.fillNo === dealer?.fillNo)
                );

                return {
                    _id: dealer?._id || 'N/A',
                    PaymentDate: entry?.PaymentDate,
                    PaymentAmount: entry?.PaymentAmount,
                    PaymentTDS: entry?.PaymentTDS,
                    type: state.type,
                    requestStatus: "Complete"
                };
            })
            .filter(entry => entry !== null); // only keep valid ones

        if (validEntries.length === 0) {
            alert("Please fill Date, Payment, and TDS in at least one row before submitting.");
            return;
        }

        // // If all partially filled rows are valid, now filter complete rows to submit
        // const validEntries = values.fileDetails.filter(row =>
        //     row.PaymentDate && row.PaymentAmount && row.PaymentTDS
        // );

        if (validEntries.length === 0) {
            alert("At least one complete payment entry is required.");
            return;
        }

        if (isEditMode) {
            dispatch(createInstallerPayment(validEntries));
            // Edit API logic
            console.log("Edit Mode Submit:", validEntries);
        } else {
            dispatch(createInstallerPayment(validEntries));
            // Create API logic
            console.log("Create Mode Submit:", validEntries);
        }

        navigate('/admin/installer-payment');
        resetForm();
    };


    const { handleBlur, handleChange, values, touched, errors, resetForm, setFieldValue, setValues, validateForm } = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchemas,
    });


    const renderFabRows = (dealers) => {
        console.log("dealerssss", dealers);
        
        const totalLength = Math.max(dealers?.length);
        while (dealers?.length < totalLength) {
            dealers?.push({});
        }
        const rows = [];
        for (let i = 0; i < totalLength; i++) {
            const dealer = dealers[i] || {};
            // const foundItem = dealer.marketData?.[0] || {};

            const liasoningId = dealer.liasoningId;
            const liasoning = assignInstaller?.find(lis => lis.liasoningData?.some(ld => ld._id === liasoningId));
            const foundItem = assignInstaller?.find(item => item?.marketData?.some(md => md.fillNo === liasoning?.liasoningData[0]?.fillNo));
            const fillNo = foundItem?.marketData[0]?.fillNo || 'N/A';

            rows.push(
                <TableRow key={`dealer-${i}`}>
                    <TableCell sx={{ fontSize: '13.5px' }}>{fillNo || '-'}</TableCell>
                    <TableCell sx={{ fontSize: '13.5px', textWrap: 'nowrap' }}>{foundItem?.marketData[0]?.ConsumerName || '-'}</TableCell>
                    <TableCell sx={{ fontSize: '13.5px' }}>{dealer.SystemSize || '-'}</TableCell>
                    <TableCell sx={{ fontSize: '13.5px' }}>{dealer.RateKw || '-'}</TableCell>
                    <TableCell sx={{ fontSize: '13.5px' }}>{dealer.TotalAmount || '-'}</TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="date"
                                label="Date :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.fileDetails?.[i]?.PaymentDate || ''}
                                name={`fileDetails[${i}].PaymentDate`}
                                error={
                                    !!touched.fileDetails?.[i]?.PaymentDate &&
                                    !!errors.fileDetails?.[i]?.PaymentDate
                                }
                                helperText={
                                    touched.fileDetails?.[i]?.PaymentDate &&
                                    errors.fileDetails?.[i]?.PaymentDate
                                }
                                InputLabelProps={{
                                    shrink: true,
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Payment Amount :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.fileDetails?.[i]?.PaymentAmount || ''}
                                name={`fileDetails[${i}].PaymentAmount`}
                                error={
                                    !!touched.fileDetails?.[i]?.PaymentAmount &&
                                    !!errors.fileDetails?.[i]?.PaymentAmount
                                }
                                helperText={
                                    touched.fileDetails?.[i]?.PaymentAmount &&
                                    errors.fileDetails?.[i]?.PaymentAmount
                                }
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Payment TDS :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.fileDetails?.[i]?.PaymentTDS || ''}
                                name={`fileDetails[${i}].PaymentTDS`}
                                error={
                                    !!touched.fileDetails?.[i]?.PaymentTDS &&
                                    !!errors.fileDetails?.[i]?.PaymentTDS
                                }
                                helperText={
                                    touched.fileDetails?.[i]?.PaymentTDS &&
                                    errors.fileDetails?.[i]?.PaymentTDS
                                }
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Payment Total :"
                                onBlur={handleBlur}
                                value={
                                    Number(values.fileDetails?.[i]?.PaymentAmount || 0) +
                                    Number(values.fileDetails?.[i]?.PaymentTDS || 0)
                                }
                                name={`fileDetails[${i}].PaymentTotal`}
                                error={
                                    !!touched.fileDetails?.[i]?.PaymentTotal &&
                                    !!errors.fileDetails?.[i]?.PaymentTotal
                                }
                                helperText={
                                    touched.fileDetails?.[i]?.PaymentTotal &&
                                    errors.fileDetails?.[i]?.PaymentTotal
                                }
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                </TableRow>
            );
        }
        return rows;
    };

    const renderEleRows = (dealers) => {

        console.log("dealersdealers", dealers, values);

        const totalLength = Math.max(dealers.length);
        while (dealers.length < totalLength) {
            dealers.push({});
        }
        const rows = [];
        for (let i = 0; i < totalLength; i++) {
            const dealer = dealers[i] || {};
            // const foundItem = dealer.marketData?.[0] || {};

            const liasoningId = dealer.liasoningId;
            const liasoning = assignInstaller?.find(lis => lis.liasoningData?.some(ld => ld._id === liasoningId));
            const foundItem = assignInstaller?.find(item => item?.marketData?.some(md => md.fillNo === liasoning?.liasoningData[0]?.fillNo));
            const fillNo = foundItem?.marketData[0]?.fillNo || 'N/A';

            rows.push(
                <TableRow key={`dealer-${i}`}>
                    <TableCell sx={{ fontSize: '13.5px' }}>{fillNo || '-'}</TableCell>
                    <TableCell sx={{ fontSize: '13.5px', textWrap: 'nowrap' }}>{foundItem?.marketData[0]?.ConsumerName || '-'}</TableCell>
                    <TableCell sx={{ fontSize: '13.5px' }}>{dealer.SystemSize || '-'}</TableCell>
                    <TableCell sx={{ fontSize: '13.5px' }}>{dealer.RateKw || '-'}</TableCell>
                    <TableCell sx={{ fontSize: '13.5px' }}>{dealer.TotalAmount || '-'}</TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="date"
                                label="Date :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.fileDetails?.[i]?.PaymentDate || ''}
                                name={`fileDetails[${i}].PaymentDate`}
                                error={
                                    !!touched.fileDetails?.[i]?.PaymentDate &&
                                    !!errors.fileDetails?.[i]?.PaymentDate
                                }
                                helperText={
                                    touched.fileDetails?.[i]?.PaymentDate &&
                                    errors.fileDetails?.[i]?.PaymentDate
                                }
                                InputLabelProps={{
                                    shrink: true,
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Payment Amount :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.fileDetails?.[i]?.PaymentAmount || ''}
                                name={`fileDetails[${i}].PaymentAmount`}
                                error={
                                    !!touched.fileDetails?.[i]?.PaymentAmount &&
                                    !!errors.fileDetails?.[i]?.PaymentAmount
                                }
                                helperText={
                                    touched.fileDetails?.[i]?.PaymentAmount &&
                                    errors.fileDetails?.[i]?.PaymentAmount
                                }
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Payment TDS :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.fileDetails?.[i]?.PaymentTDS || ''}
                                name={`fileDetails[${i}].PaymentTDS`}
                                error={
                                    !!touched.fileDetails?.[i]?.PaymentTDS &&
                                    !!errors.fileDetails?.[i]?.PaymentTDS
                                }
                                helperText={
                                    touched.fileDetails?.[i]?.PaymentTDS &&
                                    errors.fileDetails?.[i]?.PaymentTDS
                                }
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Payment Total :"
                                onBlur={handleBlur}
                                value={
                                    Number(values.fileDetails?.[i]?.PaymentAmount || 0) +
                                    Number(values.fileDetails?.[i]?.PaymentTDS || 0)
                                }
                                name={`fileDetails[${i}].PaymentTotal`}
                                error={
                                    !!touched.fileDetails?.[i]?.PaymentTotal &&
                                    !!errors.fileDetails?.[i]?.PaymentTotal
                                }
                                helperText={
                                    touched.fileDetails?.[i]?.PaymentTotal &&
                                    errors.fileDetails?.[i]?.PaymentTotal
                                }
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                </TableRow>
            );
        }
        return rows;
    };

    const renderTechRows = (dealers) => {
        console.log("dealersdealerstttt", dealers)
        const totalLength = Math.max(dealers?.length);
        while (dealers?.length < totalLength) {
            dealers.push({});
        }
        const rows = [];
        for (let i = 0; i < totalLength; i++) {
            const dealer = dealers[i] || {};
            // const foundItem = dealer.marketData?.[0] || {};

            const liasoningId = dealer.liasoningId;
            const liasoning = assignInstaller?.find(lis => lis.liasoningData?.some(ld => ld._id === liasoningId));
            const foundItem = assignInstaller?.find(item => item?.marketData?.some(md => md.fillNo === liasoning?.liasoningData[0]?.fillNo));
            const fillNo = foundItem?.marketData[0]?.fillNo || 'N/A';

            rows.push(
                <TableRow key={`dealer-${i}`}>
                    <TableCell sx={{ fontSize: '13.5px' }}>{fillNo || '-'}</TableCell>
                    <TableCell sx={{ fontSize: '13.5px', textWrap: 'nowrap' }}>{foundItem?.marketData[0]?.ConsumerName || '-'}</TableCell>
                    <TableCell sx={{ fontSize: '13.5px' }}>{dealer.SystemSize || '-'}</TableCell>
                    <TableCell sx={{ fontSize: '13.5px' }}>{dealer.Amount|| '-'}</TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="date"
                                label="Date :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.fileDetails?.[i]?.PaymentDate || ''}
                                name={`fileDetails[${i}].PaymentDate`}
                                error={
                                    !!touched.fileDetails?.[i]?.PaymentDate &&
                                    !!errors.fileDetails?.[i]?.PaymentDate
                                }
                                helperText={
                                    touched.fileDetails?.[i]?.PaymentDate &&
                                    errors.fileDetails?.[i]?.PaymentDate
                                }
                                InputLabelProps={{
                                    shrink: true,
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Payment Amount :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.fileDetails?.[i]?.PaymentAmount || ''}
                                name={`fileDetails[${i}].PaymentAmount`}
                                error={
                                    !!touched.fileDetails?.[i]?.PaymentAmount &&
                                    !!errors.fileDetails?.[i]?.PaymentAmount
                                }
                                helperText={
                                    touched.fileDetails?.[i]?.PaymentAmount &&
                                    errors.fileDetails?.[i]?.PaymentAmount
                                }
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Payment TDS :"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.fileDetails?.[i]?.PaymentTDS || ''}
                                name={`fileDetails[${i}].PaymentTDS`}
                                error={
                                    !!touched.fileDetails?.[i]?.PaymentTDS &&
                                    !!errors.fileDetails?.[i]?.PaymentTDS
                                }
                                helperText={
                                    touched.fileDetails?.[i]?.PaymentTDS &&
                                    errors.fileDetails?.[i]?.PaymentTDS
                                }
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell>
                        <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                            <TextField
                                fullWidth
                                variant="filled"
                                type="text"
                                label="Payment Total :"
                                onBlur={handleBlur}
                                value={
                                    Number(values.fileDetails?.[i]?.PaymentAmount || 0) +
                                    Number(values.fileDetails?.[i]?.PaymentTDS || 0)
                                }
                                name={`fileDetails[${i}].PaymentTotal`}
                                error={
                                    !!touched.fileDetails?.[i]?.PaymentTotal &&
                                    !!errors.fileDetails?.[i]?.PaymentTotal
                                }
                                helperText={
                                    touched.fileDetails?.[i]?.PaymentTotal &&
                                    errors.fileDetails?.[i]?.PaymentTotal
                                }
                                InputLabelProps={{
                                    style: {
                                        color: theme.palette.text.primary,
                                    },
                                }}
                            />
                        </FormControl>
                    </TableCell>
                </TableRow>
            );
        }
        return rows;
    };

    console.log("stateeeeeeeeeeee", state);



    return (
        <SnackbarProvider maxSnack={3}>
            <Box m="2px" sx={{ overflow: isMobile ? 'auto' : 'hidden', }}>
                <Header
                    title="INSTALLER PAYMENT"
                    subtitle="Manage Your Installer Payment Here"
                />
                {type === 'fabricator' && state?.electricians?.length > 0 && (

                    <Box sx={{
                        m: 3, ml: 0, mr: 0, p: 3, borderRadius: 2,
                        bgcolor: theme.palette.mode === 'dark' ? '#1f2a40' : '#f0f0f0',
                    }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            Invoice No: {paymentData?.invoiceNo} &nbsp;&nbsp;&nbsp;&nbsp;
                            Type: Fabricator &nbsp;&nbsp;&nbsp;&nbsp;
                            Total Amount: {paymentData?.amount % 1 === 0 ? paymentData?.amount.toString() : paymentData?.amount.toFixed(2)}
                        </Typography>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            {state?.electricians?.length > 0 ? state?.electricians?.map(dealer => {
                                const liasoningId = dealer.liasoningId;
                                const liasoning = assignInstaller?.find(lis => lis.liasoningData?.some(ld => ld._id === liasoningId));
                                const foundItem = assignInstaller?.find(item => item?.marketData?.some(md => md.fillNo === liasoning?.liasoningData[0]?.fillNo));
                                const fillNo = foundItem?.marketData[0]?.fillNo || 'N/A';
                                const dealerCommission = dealer?.TotalAmount || 'N/A';
                                return (
                                    <div key={dealer._id}>
                                        File No: {fillNo} - {dealerCommission}
                                    </div>
                                );
                            }) : 'N/A'}
                        </Typography>
                        <TableContainer>
                            <Table style={{ width: '100%' }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>File No.</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Name</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>System Size</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Installation Per KW</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Total Amount</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Date</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Payment</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>TDS</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Total</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody >

                                    {renderFabRows(state?.electricians)}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                )}

                {type === 'electrician' && state?.electricians.length > 0 && (
                    <Box sx={{
                        m: 3, ml: 0, mr: 0, p: 3, borderRadius: 2,
                        bgcolor: theme.palette.mode === 'dark' ? '#1f2a40' : '#f0f0f0',
                    }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            Invoice No: {paymentData?.invoiceNo} &nbsp;&nbsp;&nbsp;&nbsp;
                            Type: Electrician &nbsp;&nbsp;&nbsp;&nbsp;
                            Total Amount: {paymentData?.amount % 1 === 0 ? paymentData?.amount.toString() : paymentData?.amount.toFixed(2)}
                        </Typography>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            {state?.electricians.map((v, index) => {
                                const liasoningId = v.liasoningId;
                                const liasoning = assignInstaller?.find(lis => lis.liasoningData?.some(ld => ld._id === liasoningId));
                                const foundItem = assignInstaller?.find(item => item?.marketData?.some(md => md.fillNo === liasoning?.liasoningData[0]?.fillNo));
                                const fillNo = foundItem?.marketData[0]?.fillNo || 'N/A';
                                const dealerCommission = v?.TotalAmount || 'N/A';
                                // console.log("electricianataelectricianata", electricianata)

                                // <></>

                                {

                                    return (
                                        <div key={v._id}>
                                            File No: {fillNo} - {dealerCommission}
                                        </div>
                                    );

                                }


                            })}
                        </Typography>
                        <TableContainer>
                            <Table style={{ width: '100%' }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>File No.</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Name</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>System Size</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Installation Per KW</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Total Amount</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Date</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Payment</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>TDS</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Total</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody >
                                    {renderEleRows(state?.electricians)}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                )}

                {type === 'technician' && state?.electricians?.length > 0 && (
                    <Box sx={{
                        m: 3, ml: 0, mr: 0, p: 3, borderRadius: 2,
                        bgcolor: theme.palette.mode === 'dark' ? '#1f2a40' : '#f0f0f0',
                    }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            Invoice No: {paymentData?.invoiceNo} &nbsp;&nbsp;&nbsp;&nbsp;
                            Type: Technician &nbsp;&nbsp;&nbsp;&nbsp;
                            Total Amount: {paymentData?.amount % 1 === 0 ? paymentData?.amount.toString() : paymentData?.amount.toFixed(2)}
                        </Typography>


                        <Typography variant="h6" sx={{ mb: 2 }}>
                            {state?.electricians?.length > 0 ? state?.electricians?.map(dealer => {
                                const liasoningId = dealer.liasoningId;
                                const liasoning = assignInstaller?.find(lis => lis.liasoningData?.some(ld => ld._id === liasoningId));
                                const foundItem = assignInstaller?.find(item => item?.marketData?.some(md => md.fillNo === liasoning?.liasoningData[0]?.fillNo));
                                const fillNo = foundItem?.marketData[0]?.fillNo || 'N/A';
                                const dealerCommission = dealer?.Amount || 'N/A';
                                return (
                                    <div key={dealer._id}>
                                        File No: {fillNo} - {dealerCommission}
                                    </div>
                                );
                            }) : 'N/A'}
                        </Typography>

                        <TableContainer>
                            <Table style={{ width: '100%' }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>File No.</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Name</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>System Size</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Total Amount</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Date</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Payment</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>TDS</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Total</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody >
                                    {renderTechRows(state?.electricians)}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                )}

                <Box display="flex" mt={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{
                            boxShadow: 5,
                            '&:hover': {
                                boxShadow: 6,
                            }
                        }}
                        onClick={handleSubmit}
                    >
                        Accept Request
                    </Button>
                </Box>
            </Box>
        </SnackbarProvider>
    )
}

export default AddInstaller
